import clsx from 'clsx';
import type { NodeState } from '@/lib/types';

export function StatusDot({ state }: { state: NodeState }) {
  const on = state.kind === 'active' || state.kind === 'flash';
  const flash = state.kind === 'flash';
  return (
    <span
      className={clsx(
        'inline-block w-2.5 h-2.5 rounded-full transition-colors duration-200',
        on ? 'bg-signal-on' : 'bg-signal-off',
        on && !flash && 'signal-pulse',
        flash && 'signal-flash'
      )}
      aria-label={state.kind}
    />
  );
}
